// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DollarOutlinedSvg from "@ant-design/icons-svg/es/asn/DollarOutlined";
import AntdIcon from '../components/AntdIcon';

var DollarOutlined = function DollarOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: DollarOutlinedSvg
  }));
};

DollarOutlined.displayName = 'DollarOutlined';
export default React.forwardRef(DollarOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/DollarOutlined.js
// module id = 961
// module chunks = 0